/** Professional Flynaut-style hub icons.
 *  Thin-stroke (1.4px), geometric, monochrome. No fills, no decorative flair.
 *  Consistent visual weight across all 6 hubs so the sidebar feels unified.
 *  Uses `currentColor` so parent text color drives the stroke.
 */

const base = (size = 22) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.4,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
});

// Marketing - stacked sound waves radiating from a corner
export function MarketingHubIcon(props = {}) {
  return (
    <svg {...base(props.size)} {...props}>
      <path d="M5 19L5 5" />
      <path d="M5 19h14" />
      <path d="M9 12a3 3 0 0 1 6 0" />
      <path d="M7 12a5 5 0 0 1 10 0" />
      <path d="M5 12a7 7 0 0 1 14 0" />
    </svg>
  );
}

// Sales - clean trending line chart
export function SalesHubIcon(props = {}) {
  return (
    <svg {...base(props.size)} {...props}>
      <path d="M4 19L4 5" />
      <path d="M4 19h16" />
      <path d="M7 15l4-4 3 2 5-5" />
      <path d="M15 8h4v4" />
    </svg>
  );
}

// Recruitment - person with a plus (new hire / candidate)
export function RecruitmentHubIcon(props = {}) {
  return (
    <svg {...base(props.size)} {...props}>
      <circle cx="10" cy="8" r="3.5" />
      <path d="M4 20v-1a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5v1" />
      <path d="M18 6v6" />
      <path d="M15 9h6" />
    </svg>
  );
}

// Content - document with lines
export function ContentHubIcon(props = {}) {
  return (
    <svg {...base(props.size)} {...props}>
      <path d="M7 3h8l4 4v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M14 3v5h5" />
      <path d="M9 13h8" />
      <path d="M9 17h5" />
    </svg>
  );
}

// Admin - shield with a horizontal divider (system control)
export function AdminHubIcon(props = {}) {
  return (
    <svg {...base(props.size)} {...props}>
      <path d="M12 3l8 3v6c0 4.5-3.3 8.4-8 9-4.7-.6-8-4.5-8-9V6l8-3z" />
      <path d="M8 12h8" />
      <path d="M12 8v8" />
    </svg>
  );
}

// HR - three people silhouettes, clean and consistent
export function HRHubIcon(props = {}) {
  return (
    <svg {...base(props.size)} {...props}>
      <circle cx="12" cy="8" r="3" />
      <circle cx="5" cy="10" r="2.2" />
      <circle cx="19" cy="10" r="2.2" />
      <path d="M7 19v-1a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v1" />
      <path d="M1 18a4 4 0 0 1 4-4" />
      <path d="M23 18a4 4 0 0 0-4-4" />
    </svg>
  );
}
